import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Routes, Route } from 'react-router-dom'

// @@imports.append.start@@
// @@oidc-react-client-sdk-app-imports-append.item.start@@
import { AuthProvider, withAuth } from 'oidc-react'
import oidcConfig from './config/oidc-config.js'

import SignIn from './components/SignIn.js'
import SignUp from './components/SignUp.js'
import AddIdentity from './components/AddIdentity.js'
import SignOut from './components/SignOut.js'
import Callback from './components/Callback.js'
import SignOutCallback from './components/SignOutCallback.js'
import RefreshToken from './components/RefreshToken.js'
// @@oidc-react-client-sdk-app-imports-append.item.end@@
// @@imports.append.end@@

function App() {
  return (
    <Router>
      {
        // @@routes.append.start@@
        // @@oidc-react-client-sdk-app-routes-append.item.start@@
        <AuthProvider {...oidcConfig}>
          <Routes>
            <Route path="/signin" Component={SignIn} />
            <Route path="/login" Component={SignIn} />
            <Route path="/signup" Component={SignUp} />
            <Route path="/add-identity" Component={withAuth(AddIdentity)} />
            <Route path="/callback" Component={withAuth(Callback)} />
            <Route path="/signout" Component={withAuth(SignOut)} />
            <Route path="/logout" Component={withAuth(SignOut)} />
            <Route path="/signout-callback" Component={SignOutCallback} />
            <Route path="/refresh-token" Component={RefreshToken} />
          </Routes>
        </AuthProvider>
        // @@oidc-react-client-sdk-app-routes-append.item.end@@
        // @@routes.append.end@@
      }
    </Router>
  )
}

export default App
